import { Component, OnInit } from '@angular/core';
import { FormControl, FormGroup } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { CustomValidators } from 'src/app/shared/custom-validators';
import { FormValidatorService } from 'src/app/shared/services/form-validator.service';
import { ImageUploadHandlerService } from 'src/app/shared/services/image-upload-handler.service';
import { Validators } from 'src/app/shared/validators';
import { BillBillerServiceListService } from '../../bill-billerService/services/billerService-list.service';
import { BillCategoryListService } from '../../bill-category/services/bill-category-list.service';
import { BillProviderListService } from '../../bill-provider/services/bill-provider-list.service';
import { handleBillImagesService } from '../../uploadImage.service';
import { BillServiceAddBillerServiceService } from '../services/bill-service-add-biller-service.service';
import { BillServiceAddService } from '../services/bill-service-add.service';
import { BillServiceGetBillerServiceService } from '../services/bill-service-get-biller-service.service';
import { BillServiceGetService } from '../services/bill-service-get.service';
import { BillServiceUpdateBillerService } from '../services/bill-service-update-biller.service';
import { BillServiceUpdateService } from '../services/bill-service-update.service';
import { BillerCreateCashbackService } from '../services/biller-create-cashback.service';
import { BillerGetOrCreateCashBackService } from '../services/biller-get-or-create-cash-back.service';
import { BillerUpdateCashBackService } from '../services/biller-update-cash-back.service';
import Swal from 'sweetalert2';

@Component({
  selector: 'app-manage-bill-service',
  templateUrl: './manage-bill-service.component.html',
  styleUrls: ['./manage-bill-service.component.scss'],
})
export class ManageBillServiceComponent implements OnInit {
  manageBillServiceForm!: FormGroup;
  success = false;
  editMode = false;
  id: any;
  billerServiceId: number;
  serviceId: number;
  providers: { ID: number; name: string }[] = [];
  categories: { ID: number; name: string }[] = [];
  billerServices: { ID: number; name: string, BEEServiceId: number }[] = [];
  cashBackAmountTypes: {name: string, value: boolean}[]
 // dropdown list
  config: any = {};

  constructor(
    private translate: TranslateService,
    public formValidator: FormValidatorService,
    private addBillService: BillServiceAddService,
    private activatedRoute: ActivatedRoute,
    private getBillService: BillServiceGetService,
    private router: Router,
    private updateBillService: BillServiceUpdateService,
    private snackBar: MatSnackBar,
    private billCategoryList: BillCategoryListService,
    private billProviderList: BillProviderListService,
    private billBillerServiceList: BillBillerServiceListService,
    private imageUpload: ImageUploadHandlerService,
    private imageUploadRqst: handleBillImagesService,
    private billServiceAddBillerService: BillServiceAddBillerServiceService,
    private billServiceGetBillerService: BillServiceGetBillerServiceService,
    private billServiceUpdateBillerService: BillServiceUpdateBillerService,
    private billerGetOrCreateCashBackService: BillerGetOrCreateCashBackService,
    private billerCreateCashBack: BillerCreateCashbackService,
    private billerUpdateCashBack: BillerUpdateCashBackService
  ) {
    this.imageUploadRqst.setImagePath('Service');
    this.cashBackAmountTypes = [
      {name: "Percentage", value: true},
      {name: "Amount", value: false}
    ]
  }
  async uploadImage(image: any) {
    this.imageUpload.setUploaderService(this.imageUploadRqst);
    await this.imageUpload.setImageFile(image);
    return await this.imageUpload.upload();
  }
  controllers: any = {
    image: {
      fieldName: 'image',
      fieldType: 'product_image',
      isStaticUI: true,
      defaultValue: '',
      // validators: [
      //   {
      //     validatorFn: Validators.required,
      //     message: this.translate.instant('FORMS.VALIDATION.TEXT_ONLY', {
      //       field: 'Service Image',
      //     }),
      //   },
      // ],
    },
  };
  async ngOnInit() {

    this.config = {
      search: true,
      noResultsFound: 'No results found!',
      height: '200px',
      displayKey: "name",
    }

    await this.activatedRoute.params.subscribe(async (a) => {
      // id belongs to biller_service table
      const billerServiceId = a['id']
      const serviceId = a['serviceId']
      if (billerServiceId && serviceId) {
        this.editMode = true;
        this.billerServiceId = billerServiceId;
        this.serviceId = serviceId
        // deals with service table
        this.getBillService.setParams({ ID: serviceId });
        const response = await this.getBillService.make();
        console.log(response);
        await this.initForm();

        this.manageBillServiceForm.valueChanges.subscribe((formValues) => {
          const cashAmountController = this.manageBillServiceForm.controls['cashBackAmount']
          const cashBackPercentage = this.manageBillServiceForm.controls['cashBackPercentage']

          if(cashBackPercentage.value == true && cashAmountController.value > 100){
            this.manageBillServiceForm.controls['cashBackAmount'].setErrors({ incorrect: true })
          }else{
            this.manageBillServiceForm.controls['cashBackAmount'].setErrors(null);
          }
        });

        this.billServiceGetBillerService.setParams({ id: serviceId });
        const res = await this.billServiceGetBillerService.make();
        this.billerServiceId = res.BillerService.ID;

        this.billerGetOrCreateCashBackService.setParams({ serviceId: billerServiceId });
        const cashBack = (await this.billerGetOrCreateCashBackService.make())?.cashbackServices;


        this.manageBillServiceForm.controls['cashBackPercentage'].setValue(
          cashBack.percentage
        );
        this.manageBillServiceForm.controls['cashBackAmount'].setValue(
          cashBack.amount
        );
        this.manageBillServiceForm.controls['cashBackEnable'].setValue(
          cashBack.enable
        );

        this.manageBillServiceForm.controls['name'].setValue(response.name);
        this.manageBillServiceForm.controls['image'].setValue(response.image);
        const showedProvider = {
          name: this.providers.find((data) => data.ID == res.BillerService.ProviderID).name,
          ID: res.BillerService.ProviderID
        }
        this.manageBillServiceForm.controls['providerId'].setValue(showedProvider);

        const showedCategory = {
          name: this.categories.find((data) => data.ID == res.BillerService.CategoryID).name,
          ID: res.BillerService.CategoryID
        }
        this.manageBillServiceForm.controls['categoryId'].setValue(showedCategory);
        const billerService = this.billerServices.filter((e) => e.BEEServiceId === res.BillerService.Bill_Service_ID)
        const showedBillerService = {
          name: this.billerServices.find((data) => data.ID ==  billerService[0].ID).name,
          ID:  billerService[0].ID
        }
        this.manageBillServiceForm.controls['billerService'].setValue(showedBillerService);
      } else {
        this.initForm();
      }
    });
  }

  async initForm() {
    this.manageBillServiceForm = this.formValidator.createForm([
      {
        fieldName: 'name',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'service name',
            }),
          },
          {
            validatorFn: CustomValidators.customPattern(/^[a-zA-Z ]*$/),
            message: this.translate.instant('FORMS.VALIDATION.TEXT_ONLY', {
              field: 'service name',
            }),
          },
          {
            validatorFn: Validators.minLength(2),
            message: this.translate.instant('FORMS.VALIDATION.MINIMUM_LENGTH', {
              field: 'service name',
              value: 2,
            }),
          },
        ],
      },
      {
        fieldName: 'providerId',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'Provider',
            }),
          },
        ],
      },
      {
        fieldName: 'categoryId',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'Category',
            }),
          },
        ],
      },
      {
        fieldName: 'billerService',
        defaultValue: null,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'Biller Service',
            }),
          },
        ],
      },
      // cashback
      {
        fieldName: 'cashBackPercentage',
        defaultValue: true,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'percentage',
            }),
          },
        ],
      },
      {
        fieldName: 'cashBackAmount',
        defaultValue: 0,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'amount',
            }),
          },
          {
            validatorFn: Validators.pattern("[+]?([0-9]+([.][0-9]*)?|[.][0-9]+)"),
            message: this.translate.instant('FORMS.VALIDATION.POSITIVE_NUMBER', {
              field: 'amount',
            }),
          },
        ],
      },
      {
        fieldName: 'cashBackEnable',
        defaultValue: false,
        validators: [
          {
            validatorFn: Validators.required,
            message: this.translate.instant('FORMS.VALIDATION.REQUIRED', {
              field: 'enable',
            }),
          },
        ],
      },
      this.controllers['image'],
    ]);
    try {
      this.categories = await this.billCategoryList.make();
      this.providers = await this.billProviderList.make();
      this.billerServices = await this.billBillerServiceList.make();
    } catch (err) {
      console.log(err);
    }
  }


  async onSubmit() {
    try {
      let imagePath;
      const imgVal = this.manageBillServiceForm.value.image;

      if (typeof imgVal == 'object') {
        imagePath = (await this.uploadImage(imgVal)).location || null;
      } else {
        imagePath = imgVal || null;
      }
      if (this.editMode) {
        this.editMode = false;
        const data = {
          providerId: this.manageBillServiceForm.value.providerId.ID,
          categoryId: this.manageBillServiceForm.value.categoryId.ID,
          billerService: this.manageBillServiceForm.value.billerService.ID,
          name: this.manageBillServiceForm.value.name,
          cashBackAmount: this.manageBillServiceForm.value.cashBackAmount,
          cashBackEnable: this.manageBillServiceForm.value.cashBackEnable,
          cashBackPercentage: this.manageBillServiceForm.value.cashBackPercentage,
          image: imagePath,
        }
        this.updateBillService.setParams({
          ID: this.serviceId,
          data,
        });
        const res = await this.updateBillService.make();
        if (res.success === true) {
            this.billServiceUpdateBillerService.setParams({
              id: this.billerServiceId,
              serviceListId: this.manageBillServiceForm.value.billerService.ID,
              categoryId: this.manageBillServiceForm.value.categoryId.ID,
              providerId: this.manageBillServiceForm.value.providerId.ID,
              serviceId: this.serviceId
            });
            await this.billServiceUpdateBillerService.make();

            if(this.manageBillServiceForm.value.cashBackEnable){
              this.billerUpdateCashBack.setParams({
                serviceId: this.billerServiceId,
                amount: this.manageBillServiceForm.value.cashBackAmount,
                percentage: this.manageBillServiceForm.value.cashBackPercentage,
                enable: this.manageBillServiceForm.value.cashBackEnable
              })
              this.billerUpdateCashBack.make();
            }
          this.success = true;
          this.snackBar.open(`Bill service Added Successfully!`, '', {
            duration: 3000,
          });
        }
      } else {
        this.addBillService.setParams({
          image: imagePath,
          name: this.manageBillServiceForm.value.name,
          providerId: this.manageBillServiceForm.value.providerId.ID,
          categoryId: this.manageBillServiceForm.value.categoryId.ID,
          billerService: this.manageBillServiceForm.value.billerService.ID
        });
        const res = await this.addBillService.make();
          if (res.success === true) {
            this.billServiceAddBillerService.setParams({
              serviceListId: this.manageBillServiceForm.value.billerService.ID,
              categoryId: this.manageBillServiceForm.value.categoryId.ID,
              providerId: this.manageBillServiceForm.value.providerId.ID,
              serviceId: res.service.ID,
            });
            const biller_service = await this.billServiceAddBillerService.make();
            if(biller_service.success){
              this.billerCreateCashBack.setParams({
                serviceId: biller_service.BillerService.ID,
                amount: this.manageBillServiceForm.value.cashBackAmount,
                percentage: this.manageBillServiceForm.value.cashBackPercentage,
                enable: this.manageBillServiceForm.value.cashBackEnable
              });
              await this.billerCreateCashBack.make()
            }
            this.success = true;
            this.snackBar.open(`Bill Service Edited Successfully!`, '', {
              duration: 3000,
            });
          }
      }

      this.router.navigate(['/admin/actions/bill-services']);
    } catch (err) {
      if (err.validationErrors) this.handelFormValidationErrors(err.validationErrors);
      if (err.faultyRequest?.error) await this.handelBackEndErrors(err.faultyRequest);
    }

  }
  convertControls(name: string) {
    return this.manageBillServiceForm.get(name) as FormControl;
  }

  async handelBackEndErrors(error: any){
    console.log("error", error);
    const errMsg = error?.error?.message ?? "Something wrong happened.";
     Swal.fire({
      title: "Oops",
      text: errMsg,
      icon: 'warning'
    })
  }

  handelFormValidationErrors(validationErrors: any){
    const e = validationErrors.error;
    for (const error of e) {
      this.formValidator.addError(error.field, 'invalid', error.message);
      this.manageBillServiceForm.controls[error.field].setErrors({
        invalid: error.message,
      });
      this.formValidator.ShowErrors();
    }
  }
}
